export default __webpack_public_path__ + "static/media/homesl3.99997f5d.png";